/**
 * @class ProductSearchOption
 * @description This class based object handles transforming the data received from API,
 * After receiving the data, it will append its value into listBillItem
 *
 * @property {String | Number} productId - The ID of the product.
 * @property {String} productName - The name of the product.
 * @property {String} productCode - The code of the product.
 * @property {Number} productCategory - The category of the product.
 * @property {String} productNameVat - The VAT name of the product.
 * @property {String} barCode - The barcode of the product.
 * @property {Number} quantityInStock - The quantity of the product in stock.
 * @property {Number} sellingPrice - The selling price of the product.
 * @property {String} returnSellingPrice - The return selling price of the product.
 * @property {Number} productType - The type of the product.
 * @property {Object[]} listProductInCombo - A list of products included in a combo.
 * @property {Object[]} listAccessoryBonus - A list of accessory bonuses.
 * @property {Object[]} listAccessoryPromotion - A list of accessory promotions.
 * @property {Number} listedPrice - The listed price of the product.
 * @property {Number} merchantId - The ID of the merchant.
 * @property {String} warrantyAddress - The warranty address of the product.
 * @property {String} warrantyPhone - The warranty phone number of the product.
 * @property {Number} warrantyMonthNo - The warranty month number of the product.
 * @property {String} warrantyDescription - The warranty description of the product.
 */
export class ProductSearchOption {
  /**
   * @param {Object} data
   * @param {String | Number} data.productId
   * @param {String} data.productName
   * @param {String} data.productCode
   * @param {Number} data.productCategory
   * @param {String} data.productNameVat
   * @param {String} data.barCode
   * @param {String} data.imeiCode
   * @param {String} data.chassisNumber
   * @param {String} data.engineNumber
   * @param {String} data.serialNumber
   * @param {Number} data.quantityInStock
   * @param {Number} data.sellingPrice
   * @param {Number} data.importPrice
   * @param {Number} data.returnSellingPrice
   * @param {Number} data.productType
   * @param {Object[]} data.listProductInCombo
   * @param {Object[]} data.listAccessoryBonus
   * @param {Object[]} data.listAccessoryPromotion
   * @param {Number} data.listedPrice
   * @param {Number} data.merchantId
   * @param {String} data.warrantyAddress
   * @param {Number} data.warrantyPhone
   * @param {Number} data.warrantyMonthNo
   * @param {String} data.warrantyDescription
   */
  constructor(data) {
    this.productId = data.id;
    this.productName = data.name;
    this.productCode = data.code;
    this.productCategory = data.productCategory;
    this.productNameVat = data.productNameVat;
    this.categoryId = data.categoryId;
    this.barCode = data.barCode;
    this.imeiCode = data.imeiCode;
    this.productChassis = data.productChassis?.[0] || null;
    this.chassisNumber =
      this.productChassis?.chassisNumber || data.chassisNumber || null;
    this.engineNumber =
      this.productChassis?.engineNumber || data.engineNumber || null;
    this.productSeries = data.productSeries?.[0] || null;
    this.serialNumber =
      this.productSeries?.serialNumber || data.serialNumber || null;
    this.quantityInStock =
      data.productStock && data.productStock.length
        ? data.productStock[0]['inStockQuantity']
        : 0;
    this.sellingPrice = data.sellingPrice;
    this.importPrice = data.importPrice;
    this.returnSellingPrice = data.returnSellingPrice;
    this.productType = data.type;
    this.listProductInCombo = data.listProductInCombo;
    this.listAccessoryBonus = data.listAccessoryBonus;
    this.listAccessoryPromotion = data.listAccessoryPromotion;
    this.listedPrice = data.listedPrice || 0;
    this.merchantId = data.merchantId || 1;
    this.warrantyAddress = data.warrantyAddress || '';
    this.warrantyPhone = data.warrantyPhone || '';
    this.warrantyMonthNo = data.warrantyMonthNo || 0;
    this.warrantyDescription = data.warrantyDescription || '';
  }
}
